import { AddressValidationResponse } from '@app/api/models/userData';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { handleGenericError } from '@app/api/http/generic-error-handler';
import * as AuthActions from '@app/auth/store/actions/auth.action';
import { ChannelEnums } from '@app/api/models/api-models';

export enum ERROR_KEYWORDS {
  INVALID = 'INVALID',
  REQUIRED = 'REQUIRED',
}

export const ADDRESS_ERROR = 'INVALID_ADDRESS';
export const POSTAL_CODE_ERROR = 'INVALID_ZIPCODE';
export const CITY_ERROR = 'INVALID_CITY';
export const COUNTRY_ERROR = 'INVALID_COUNTRY';
export const LOCATION_ERROR = 'INVALID_LOCATION_NAME';
export const PHONE_NUMBER = 'INVALID_PHONE_NUMBER';

export const ErrorToasterConfig: MatSnackBarConfig = {
  duration: 6000,
  horizontalPosition: 'center',
  verticalPosition: 'top',
  panelClass: 'toast-fail',
};

export function filterErrors(errors) {
  const errorMessages: string[] = [];
  errors.forEach(error => {
    if (error.yextErrorCode && error.yextErrorCode.includes(ERROR_KEYWORDS.INVALID || ERROR_KEYWORDS.REQUIRED)) {
      errorMessages.push(`csa.${error.yextErrorCode}`.toLowerCase());
    }

    if (error.basicErrorCode && error.basicErrorCode.includes(ERROR_KEYWORDS.INVALID)) {
      errorMessages.push(`csa.${error.basicErrorCode}`.toLowerCase());
    }
  });
  return errorMessages;
}

export function profileErrors(errorContent) {
  let errors = [];
  if (errorContent.payload) {
    errors = errorContent.payload.errorResponse;
  } else {
    errors.push(errorContent.message.errorCode);
  }

  const errorMessages: string[] = [];
  errors.forEach(error => {
    if (error.yextErrorCode) {
      error.yextErrorCode.includes(ERROR_KEYWORDS.INVALID || ERROR_KEYWORDS.REQUIRED)
        ? errorMessages.push(`csa.${error.yextErrorCode}`.toLowerCase())
        : [];
    } else {
      error.includes(ERROR_KEYWORDS.INVALID) ? errorMessages.push(`csa.${error}`.toLowerCase()) : [];
    }
  });
  return errorMessages;
}

/** Temp fucntion do handle criation and update erros. This should be deleted once the bootstrap endpoint returned errors are revised */
export function tempFilterErrors(errorContent) {
  let errors = [];

  if (errorContent && errorContent.payload) {
    if (errorContent.payload.body) {
      errors.push(errorContent.payload.body.errorCode);
    } else {
      errors = errorContent.payload.errorResponse;
    }
  }

  return errors;
}

enum addressErrorCodeEnum {
  zipCode = 'INVALID_ZIPCODE',
  address = 'INVALID_ADDRESS',
  city = 'INVALID_CITY',
  locationName = 'INVALID_LOCATION_NAME',
  countryCode = 'INVALID_COUNTRY',
}

/**
 * Checks the addressValidation object returned by the addressValidation request
 * First verifies if there is an errorCode. If there is one, it means the address wasn't validated by google API, then the error code is added to the array and returned
 * If there is no errorCode, then it checks for the payload property. If this property exists, then it means it is a validation error on Weblisting side
 * @param addressValidation AddressValidation object
 */
export function validateAddressErrors(addressValidation: AddressValidationResponse): string[] {
  const errorCodes: string[] = [];
  const { errorCode, payload } = addressValidation;
  if (errorCode) {
    errorCodes.push(`csa.${errorCode.toLowerCase()}`);
  } else {
    // The payload is an array of errorObjects. The path property of the errorObject has the name of the address property that is invalid
    // Example: path: [zipcode]
    payload.forEach(errorObject => {
      const translationKey = `csa.${addressErrorCodeEnum[errorObject.path[0]].toLowerCase()}`;
      if (errorCodes.indexOf(translationKey) === -1) {
        errorCodes.push(`csa.${addressErrorCodeEnum[errorObject.path[0]].toLowerCase()}`);
      }
    });
  }
  return errorCodes;
}
